export enum YandexCaptchaEventNameAMP {
  SHOWED = 'captcha was showed',
  COMPLETED = 'captcha was completed',
  YANDEX_ERROR = 'captcha have error',
}
